import state from './moduleLicenseAddState.js'
import mutations from './moduleLicenseAddMutations.js'
import actions from './moduleLicenseAddActions.js'
import getters from './moduleLicenseAddGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
